<sd-store-locator
  [isPickup]="true"
  [centerOnCountry]="centerOnCountry"
  [bounds]="bounds"
  [stores]="stores"
  [title]="title"
  [searchWord]="searchWord"
  [isLoading]="isLoading"
  [isEmbedded]="isEmbedded"
  [isHob]="isHob"
  [hideCardActions]="hideCardActions"
  [repairCenter]="repairCenter"
  [mapLegend]="mapLegend"
  [mapSelectAction]="mapSelectAction"
  [searchCountryRestrictions]="searchCountryRestrictions"
  [isUserPickupInfoFormValid]="isUserPickupInfoFormValid"
  [selectedPickupId]="selectedPickupId"
  (selectedStore)="onSelectedStore($event)"
  (locate)="emitLocateEvent($event)"
>
  <div class="address-form">
    <ng-content />
  </div>
</sd-store-locator>
